import { useEffect, useCallback } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const GAME_LAUNCH = 'GAME_LAUNCH';

export const useOnGameLaunch = (eventTarget) => {
    const trackGameLaunch = useCallback(({ game, mode, options = {} }) => {
        const { gameCode, name } = game;
        const { gameName, container, gameFeed, isReactGame } = options;
        const commonDetails = {
            gameCode,
            container,
            gameName: name,
            launchType: mode ? 'Real' : 'Demo'
        };

        const event = new CustomEvent(GAME_LAUNCH, {
            detail: [{
                ...commonDetails,
                ...isReactGame && {
                    gameFeed,
                    gameName
                }
            }]
        });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('game-launch', trackGameLaunch);

        return () => {
            publicEventsAPIService.off('game-launch', trackGameLaunch);
        };
    }, [trackGameLaunch]);
};
